module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-rewards-filters"
  }, [_c('fieldset', {
    staticClass: "o-fieldset c-rewards-filters__FIXME-GREGGI-WAN-OCHABI__YOURE-MY-ONLY-HOPE"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.sort_by_label')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.sort),
      expression: "filters.sort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "sort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortOptions), function(option, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset c-rewards-filters__points-range"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.price_range')))]), _vm._v(" "), _c('div', {
    staticClass: "c-rewards-filters__points-range__input-layout"
  }, [_c('span', {
    staticClass: "c-rewards-filters__points-range__input-layout__sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.price_min),
      expression: "filters.price_min"
    }],
    staticClass: "c-rewards-filters__points-range__input-layout__input\n                       qa-rewards-filters-low-price",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('web.catalog_rewards_filters.min_points_placeholder')
    },
    domProps: {
      "value": (_vm.filters.price_min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "price_min", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-rewards-filters__points-range__input-layout__sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_to_points')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.price_max),
      expression: "filters.price_max"
    }],
    staticClass: "c-rewards-filters__points-range__input-layout__input\n                       qa-rewards-filters-high-price",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('web.catalog_rewards_filters.max_points_placeholder')
    },
    domProps: {
      "value": (_vm.filters.price_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "price_max", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.categoriesLoading) ? _c('loading-icon') : _c('div', {
    staticClass: "c-rewards-filters__category-switcher"
  }, [(!_vm.showCategorySwitcher) ? _c('div', {
    staticClass: "c-rewards-filters__category-switcher__default-view"
  }, [_c('label', {
    staticClass: "c-rewards-filters__category-switcher__default-view__label u-label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filters.category_label')) + "\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "c-rewards-filters__category-switcher__default-view__title"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedCategoryName) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-rewards-filters__category-switcher__default-view__button\n                  u-button-as-link\n                  t-link\n                  qa-change-category-button",
    on: {
      "click": function($event) {
        return _vm.toggleCategorySwitcher()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filters.change_category_link')) + "\n      ")])]) : _c('div', {
    staticClass: "c-rewards-filters__category-switcher__change-category"
  }, [_c('div', {
    staticClass: "c-rewards-filters__category-switcher__change-category__header"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.change_category_link')))]), _vm._v(" "), _c('button', {
    staticClass: "u-button-as-link t-link",
    on: {
      "click": _vm.toggleCategorySwitcher
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filters.cancel_button')) + "\n        ")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "o-radio\n                   o-radio--area-selector\n                   o-radio--no-transitions\n                   c-rewards-filters__category-switcher__change-category__radio-item\n                   qa-category-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.category),
      expression: "filters.category"
    }],
    staticClass: "o-radio__input",
    attrs: {
      "value": "",
      "type": "radio",
      "name": "filterCategory"
    },
    domProps: {
      "checked": _vm._q(_vm.filters.category, "")
    },
    on: {
      "click": _vm.selectCategory,
      "change": function($event) {
        return _vm.$set(_vm.filters, "category", "")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-radio__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.no_category')))])]), _vm._v(" "), _vm._l((_vm.$store.getters.categories), function(category) {
    return _c('li', {
      staticClass: "o-radio\n                   o-radio--area-selector\n                   o-radio--no-transitions\n                   c-rewards-filters__category-switcher__change-category__radio-item\n                   qa-category-option"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filters.category),
        expression: "filters.category"
      }],
      staticClass: "o-radio__input",
      attrs: {
        "type": "radio",
        "name": "filterCategory"
      },
      domProps: {
        "value": category.code,
        "checked": _vm._q(_vm.filters.category, category.code)
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        },
        "change": function($event) {
          return _vm.$set(_vm.filters, "category", category.code)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "o-radio__label"
    }, [_vm._v(_vm._s(_vm.getCategoryName(category)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRewardFilters),
      expression: "showRewardFilters"
    }],
    staticClass: "c-rewards-filters__filter-checkboxes"
  }, [(_vm.filtersLoading) ? _c('loading-icon') : _vm._l((_vm.$store.getters.rewardFilters), function(filter) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (filter.options.length),
        expression: "filter.options.length"
      }]
    }, [_c('label', {
      staticClass: "c-rewards-filters__filter-checkboxes__section-label u-label"
    }, [_vm._v("\n        " + _vm._s(_vm.getFilterName(filter)) + "\n      ")]), _vm._v(" "), _c('ul', _vm._l((filter.options), function(option) {
      return _c('li', {
        staticClass: "o-checkbox\n                   o-checkbox--area-selector\n                   c-rewards-filters__filter-checkboxes__checkbox-item\n                   qa-filter-option"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.filters[_vm.getFiltersKeyFor(filter)]),
          expression: "filters[getFiltersKeyFor(filter)]"
        }],
        staticClass: "o-checkbox__input",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": _vm.getOptionValueFor(option),
          "checked": Array.isArray(_vm.filters[_vm.getFiltersKeyFor(filter)]) ? _vm._i(_vm.filters[_vm.getFiltersKeyFor(filter)], _vm.getOptionValueFor(option)) > -1 : (_vm.filters[_vm.getFiltersKeyFor(filter)])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.filters[_vm.getFiltersKeyFor(filter)],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = _vm.getOptionValueFor(option),
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "o-checkbox__label"
      }, [_vm._v(_vm._s(_vm.getOptionNameFor(option)))])])
    }), 0)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cbb0406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/RewardsFilters.vue
// module id = 556
// module chunks = 1